
























































import {
  createComponent,
  ref,
  watch,
  computed,
  provide,
} from "@vue/composition-api";
import {
  SelectInputProps,
  defaultGetLabel,
  defaultGetOptionKey,
} from "./selectProps";
import { Radio, CheckboxGroup, RadioGroup, Checkbox } from "element-ui";

export default createComponent<SelectInputProps<any>>({
  components: {},
  props: {
    options: { required: true },
    value: { required: true },
    getOptionLabel: { type: Function, default: defaultGetLabel },
    getOptionKey: { type: Function, default: defaultGetOptionKey },
    multiple: { type: Boolean, default: false },
    remoteMethod: { type: Function, required: false },
    loading: { type: Boolean, default: false },
  },
  setup(props, ctx) {
    const inputElement = ref();

    const showDialog = ref(false);

    const searchText = ref("");

    const optionComponent = computed(() =>
      props.multiple ? "ElCheckbox" : "ElRadio",
    );

    const isOptionEqual = (a: any, b: any) =>
      props.getOptionKey(a) === props.getOptionKey(b);

    function isSelected(option: any) {
      if (!props.value) return false;
      if (props.multiple) {
        if (!props.value.length) return false;
        return (props.value as any[]).some((element) =>
          isOptionEqual(element, option),
        );
      } else {
        return isOptionEqual(props.value, option);
      }
    }

    function onOptionInput(option: any) {
      if (props.multiple) {
        if (!Array.isArray(props.value))
          throw new Error("Select value needs to be an array.");
        if (isSelected(option)) {
          const index = props.value.findIndex((element) =>
            isOptionEqual(element, option),
          );
          props.value.splice(index, 1);
        } else props.value.push(option);
      } else {
        // single choice
        ctx.emit("input", option);
        showDialog.value = false;
      }
    }

    watch(
      showDialog,
      (show) => {
        if (show === true) (inputElement.value as any).focus();
      },
      { flush: "post" },
    );

    watch(searchText, (text) => {
      if (props.remoteMethod) props.remoteMethod(text);
    });

    const filteredOptions = computed(() => {
      if (props.options === null) return null;
      if (props.remoteMethod) return props.options;
      else {
        const strip = (str: string) =>
          str.replace(/[^0-9a-z]/gi, "").toLowerCase();

        return props.options.filter((o) =>
          strip(props.getOptionLabel(o)).includes(strip(searchText.value)),
        );
      }
    });

    const selectedLabels = computed<string[]>(() => {
      if (props.multiple) {
        return props.value.map(props.getOptionLabel);
      } else {
        if (!props.value) return [];
        return [props.getOptionLabel(props.value)];
      }
    });

    return {
      selectedLabels,
      showDialog,
      searchText,
      inputElement,
      onOptionInput,
      isSelected,
      filteredOptions,
      optionComponent,
    };
  },
});
